import { useLocation } from "react-router-dom"
import { useMemo } from "react"
import { useMainHistory } from "../hooks"

/**
 * Hook that returns whether a modal is currently open based on the URL.
 * It recognizes this if the word “modal” appears anywhere in the URL.
 */
export function useIsModalOpen(): boolean {
    const location = useLocation()
    const mainHistory = useMainHistory()
    const searchParams = new URLSearchParams(mainHistory.location.search)

    const isModalOpen = useMemo(() => {
        return (
            location.pathname.includes("modal") ||
            location.search.includes("modal") ||
            location.hash.includes("modal") ||
            (searchParams?.get("ms") !== null && searchParams?.get("mp") !== null)
        )
    }, [location, mainHistory])

    return isModalOpen
}
